import React from "react";
import {Route, Switch as RouterSwitch, useRouteMatch} from "react-router-dom";
import {OrdersScreen} from "./screens/Orders.screen";
import {OrderScreen} from "./screens/order/Order.screen";

export const OrdersFeature = () => {
    const {path} = useRouteMatch();
    return (
        <RouterSwitch>
            <Route path={`${path}/order/:id`}>
                <OrderScreen/>
            </Route>
            <Route path={path}>
                <OrdersScreen/>
            </Route>
        </RouterSwitch>
    )
}